import { ContentWrapper, DemoSectionWrapper, MessageBox } from './scene.styles';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { SOURCES_TYPES } from '@/common/enums/source-types.enum';
import Loading from '@/common/components/Loading';
import ContantSceneManager from './components/ContantSceneManager';
import Header from './components/Header/Header';
import BackPopUp from './components/BackPopUp/BackPopUp';
import EndScreen from './components/EndScreen/EndScreen';
import SceneTutorial from './components/SceneTutorial/SceneTutorial';
import RateFeaturePopUp from '@/common/components/customer/rateFeaturePopUp/RateFeaturePopUp';
import useSceneV3 from './hooks/useSceneV3';

const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
	height: calc(var(--vh, 1vh) * 100 - 60px);
	overflow: hidden;
	text-align: center;
	margin: 0;
	padding: 0;
	background-color: white;

	@media (min-width: 600px) {
		flex-grow: 1;
		margin: 0;
		width: 100%;
		height: fit-content;
		position: relative;
	}
`;

const SceneV3 = () => {
	const { id } = useParams();

	const {
		backHandler,
		completedTasks,
		conversation,
		handleCloseTutorial,
		handleCompletedTasksChange,
		handleRefreshFunction,
		hasEnded,
		isBackPopupShown,
		isLoading,
		isRateFeaturePopUpVisible,
		isTasksListShown,
		isTutorialVisible,
		sceneContent,
		setIsBackPopupShown,
		setIsTasksListShown,
		setIsTutorialVisible,
	} = useSceneV3(id!);

	return (
		<>
			{isLoading ? (
				<Loading />
			) : (
				<PageWrapper>
					<Header
						name={sceneContent?.name}
						refresh={true}
						refreshFunction={() => handleRefreshFunction()}
						backTo={'/learn/scenes-v3'}
						forWhat={sceneContent?._id}
						source={SOURCES_TYPES.SCENE}
						tasksTotal={sceneContent?.tasks?.length}
						tasksCurrent={completedTasks.length}
						onTasksClick={() => setIsTasksListShown(true)}
						onBack={() => setIsBackPopupShown(true)}
						onTutorialClick={() => setIsTutorialVisible(true)}
					/>
					<DemoSectionWrapper>
						<ContentWrapper>
							<MessageBox>
								{sceneContent && conversation && (
									<ContantSceneManager
										conversation={conversation}
										scene={sceneContent}
										onCompletedTasksChange={handleCompletedTasksChange}
										isTasksListShown={isTasksListShown}
										setIsTasksListShown={setIsTasksListShown}
										completedTasks={completedTasks}
									/>
								)}
								<div id='bottom-info' />
							</MessageBox>
						</ContentWrapper>
					</DemoSectionWrapper>
					{isBackPopupShown && (
						<BackPopUp
							onContinue={() => setIsBackPopupShown(false)}
							onBack={backHandler}
						/>
					)}
				</PageWrapper>
			)}
			{hasEnded && <EndScreen onFinish={backHandler} />}
			{isTutorialVisible && <SceneTutorial onClose={handleCloseTutorial} />}
			{isRateFeaturePopUpVisible && (
				<RateFeaturePopUp
					forWhat={sceneContent?._id}
					type={SOURCES_TYPES.SCENE}
					onClose={backHandler}
				/>
			)}
		</>
	);
};

export default SceneV3;
